export default __webpack_public_path__ + "static/media/vegetarian.6174704c.png";